import { useMemo } from 'react';
import { useNexaStore } from '../NexaStore';
import {
  groupAndMergeTrendsLinks,
  RawFunctionCall,
  MergedConfig,
} from '../utils/dashboardLinkMerge';

/**
 * Hook to compute merged dashboard links from raw function calls
 * Uses dashboardConfigMap from the store to resolve full configs
 *
 * @param functionCalls - Raw function calls from processed events
 * @returns Object with merged configs and standalone raw function calls
 */
const useMergedDashboardLinks = (
  functionCalls: RawFunctionCall[],
): { merged: MergedConfig[]; standalone: RawFunctionCall[] } => {
  const dashboardConfigMap = useNexaStore((state) => state.dashboardConfigMap);

  return useMemo(() => {
    if (!functionCalls || functionCalls.length === 0) {
      return { merged: [], standalone: [] };
    }

    if (!dashboardConfigMap) {
      return { merged: [], standalone: functionCalls };
    }

    return groupAndMergeTrendsLinks(functionCalls, dashboardConfigMap);
  }, [functionCalls, dashboardConfigMap]);
};

export default useMergedDashboardLinks;
